import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

const LANGS = ['zh', 'en']
const STORAGE_KEY = 'sssc-lang'

const i18n = new VueI18n({
  locale: 'zh',
  fallbackLocale: 'zh',
  messages: { zh, en }
})

export function isSupportedLang(lang) {
  return LANGS.includes(lang)
}

// 从 localStorage 读取用户上次选择，默认中文
export function detectLang() {
  let saved = null
  try {
    saved = localStorage.getItem(STORAGE_KEY)
  } catch (e) {
    saved = null
  }
  return LANGS.includes(saved) ? saved : 'zh'
}

// 切换语言：更新 i18n、html lang（不写 localStorage，由路由守卫持久化）
export function setLocale(lang) {
  const l = LANGS.includes(lang) ? lang : 'zh'
  i18n.locale = l
  document.documentElement.lang = l === 'zh' ? 'zh-CN' : 'en'
  return l
}

// 由路由守卫调用，持久化语言偏好
export function persistLang(lang) {
  try {
    localStorage.setItem(STORAGE_KEY, lang)
  } catch (e) {
    /* ignore */
  }
}

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js